<template>
  <div class="user-info" @click="login_out">
    <img class="avatar" :src="user.avatar" alt="" v-show="info.userInfo.avatar">
    <div class="nickname" v-show="info.userInfo.nickname">{{user.nickname}}</div>
  </div>
</template>

<script>
  import click_handler from '../../tools/mgtv/click'
  import {login, logout} from '../../tools/mgtv/login'

  export default {
    name: 'UserInfo',
    props: ['info'],
    data() {
      return {}
    },
    computed: {
      user() {
        return window.$bus.user
      }
    },
    methods: {
      login_out() {
        //登录登出
        if (!this.user.uuid) {
          click_handler('登录', login, {
            need_login: false,
            need_act: false,
            need_vip: false
          });
        } else {
          if (window.gact.is_h5) {
            click_handler('登出', () => {
              this.$dialog.confirm({
                message: `您已登录,当前用户是${this.user.nickname}，是否需要切换账号?`
              }).then(logout).catch(() => {
                console.log('取消')
              });
            }, {
              need_login: false,
              need_act: false,
              need_vip: false
            });
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  @import "../../share/mixins.styl"

  .user-info
    display inline-block
    position relative
    width: 1rem;

  .nickname
    width: 1rem;
    padding: .02rem;
    line-height: @height;
    font-size: .16rem;
    background-color: light-gray-color;
    border-radius: .2rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: gray-color;
    border: 2px solid light-gray-color;
    text-align: center;
    margin-top: .01rem

  .avatar
    background-color: gray-color;
    width: 0.6rem;
    height: .6rem;
    border-radius: 100%;
    border: 2px solid light-gray-color;
    display block
    margin 0 auto


</style>



// WEBPACK FOOTER //
// src/components/ConfigUI/UserInfo.vue